import { handleActions } from 'redux-actions-helpers'
import * as actions from './actions'
import { InitialState } from './types'

const initialState: InitialState = {
  lesson: {
    course_id: '',
    created_at: '',
    icon_media_id: '',
    lesson_id: '',
    theme_id: '',
    title: '',
    updated_at: '',
  },
  modules: [],
  isLessonFetching: false,
  isThemesFetching: false,
  themes: [],
  isModulesFetching: false,
  isProcessConnectModuleLesson: false,
  isProcessEdit: false,
  isProcessModuleLessonEdit: false,
  isProcessModuleLessonRemove: false,
  isProcessCreateLessonRelation: false,
  isProcessEditLessonRelation: false,
  isProcessRemoveLessonRelation: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchLesson]: state => {
      return {
        ...state,
        isLessonFetching: true,
        error: initialState.error,
      }
    },
    [actions.fetchLessonSuccess]: (state, action) => {
      return {
        ...state,
        lesson: action.result,
        icon: action.result.icon_media_id,
        isLessonFetching: false,
      }
    },
    [actions.fetchLessonFailure]: (state, action) => {
      return {
        ...state,
        isLessonFetching: false,
        error: action.error,
      }
    },
    [actions.fetchThemes]: state => {
      return {
        ...state,
        isThemesFetching: true,
      }
    },
    [actions.fetchThemesSuccess]: (state, action) => {
      return {
        ...state,
        themes: action.result,
        isThemesFetching: false,
      }
    },
    [actions.fetchThemesFailure]: (state, action) => {
      return {
        ...state,
        isThemesFetching: false,
        error: action.error,
      }
    },
    [actions.editLesson]: state => {
      return {
        ...state,
        isProcessEdit: true,
      }
    },
    [actions.editLessonSuccess]: state => {
      return {
        ...state,
        isProcessEdit: false,
      }
    },
    [actions.editLessonFailure]: (state, action) => {
      return {
        ...state,
        isProcessEdit: false,
        error: action.error,
      }
    },
    [actions.fetchModules]: state => {
      return {
        ...state,
        isModulesFetching: true,
      }
    },
    [actions.fetchModulesSuccess]: (state, action) => {
      return {
        ...state,
        modules: action.result,
        isModulesFetching: false,
      }
    },
    [actions.fetchModulesFailure]: (state, action) => {
      return {
        ...state,
        isModulesFetching: false,
        error: action.error,
      }
    },
    [actions.connectModuleLesson]: state => {
      return {
        ...state,
        isProcessConnectModuleLesson: true,
      }
    },
    [actions.connectModuleLessonSuccess]: state => {
      return {
        ...state,
        isProcessConnectModuleLesson: false,
      }
    },
    [actions.connectModuleLessonFailure]: (state, action) => {
      return {
        ...state,
        isProcessConnectModuleLesson: false,
        error: action.error,
      }
    },
    [actions.editModuleLesson]: state => {
      return {
        ...state,
        isProcessModuleLessonEdit: true,
      }
    },
    [actions.editModuleLessonSuccess]: state => {
      return {
        ...state,
        isProcessModuleLessonEdit: false,
      }
    },
    [actions.editModuleLessonFailure]: (state, action) => {
      return {
        ...state,
        isProcessModuleLessonEdit: false,
        error: action.error,
      }
    },
    [actions.removeModuleLesson]: state => {
      return {
        ...state,
        isProcessModuleLessonRemove: true,
      }
    },
    [actions.removeModuleLessonSuccess]: state => {
      return {
        ...state,
        isProcessModuleLessonRemove: false,
      }
    },
    [actions.removeModuleLessonFailure]: (state, action) => {
      return {
        ...state,
        isProcessModuleLessonRemove: false,
        error: action.error,
      }
    },
    [actions.createLessonRelation]: state => {
      return {
        ...state,
        isProcessCreateLessonRelation: true,
      }
    },
    [actions.createLessonRelationSuccess]: state => {
      return {
        ...state,
        isProcessCreateLessonRelation: false,
      }
    },
    [actions.createLessonRelationFailure]: (state, action) => {
      return {
        ...state,
        isProcessCreateLessonRelation: false,
        error: action.error,
      }
    },
    [actions.editLessonRelation]: state => {
      return {
        ...state,
        isProcessEditLessonRelation: true,
      }
    },
    [actions.editLessonRelationSuccess]: state => {
      return {
        ...state,
        isProcessEditLessonRelation: false,
      }
    },
    [actions.editLessonRelationFailure]: (state, action) => {
      return {
        ...state,
        isProcessEditLessonRelation: false,
        error: action.error,
      }
    },
    [actions.removeLessonRelation]: state => {
      return {
        ...state,
        isProcessRemoveLessonRelation: true,
      }
    },
    [actions.removeLessonRelationSuccess]: state => {
      return {
        ...state,
        isProcessRemoveLessonRelation: false,
      }
    },
    [actions.removeLessonRelationFailure]: (state, action) => {
      return {
        ...state,
        isProcessRemoveLessonRelation: false,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
